import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye, FaCloudUploadAlt } from "react-icons/fa";
import { IoMdEyeOff } from "react-icons/io";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { DASHBOARD, MANAGE_INSPECTOR } from "../../utils/RouteConstant";
import SuccessBackground from "../../../asesst/SuccessBackground.svg";
import file_image from "../../../asesst/file_image.png";
import Tick from "../../../asesst/tick.svg";
import { RxCrossCircled } from "react-icons/rx";
import Breadcrumbs from "../../customComponent/BreadCrumbs";
import { breadcrumbNameMap } from "../../utils/helperData";
import {
  addInspector,
  uploadFiles,
} from "../../../redux/action/InspectorManagement/AddInspectorAction";
import { useDispatch, useSelector } from "react-redux";
import { Select, TextField } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";

const AddInspector = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isLoading, error } = useSelector((state) => state.inspector);
  const [showPassword, setShowPassword] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openSaveModal, setOpenSaveModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState({});
  const [formError, setFormError] = useState(null);
  const [backendErrors, setBackendErrors] = useState({});
  const [confirmModal, setConfirmModal] = useState(false);
  const [fileToRemove, setFileToRemove] = useState(null);

  const fileInputRef = useRef(null);

  useEffect(() => {
    return () => {
      selectedFiles.forEach((file) => URL.revokeObjectURL(file.preview));
    };
  }, [selectedFiles]);
  const validationSchema = Yup.object({
    first_name: Yup.string()
      .required("First Name is required")
      .matches(
        /^[A-Za-z][A-Za-z]*(?: [A-Za-z]+)*$/,
        "First Name must start with a letter, only letters and spaces are allowed, and spaces must follow a letter"
      ),
    last_name: Yup.string(),
    mobile: Yup.string()
      .matches(/^[0-9]\d{9}$/, "Mobile Number must be 10 digits")
      .required("Mobile Number is required"),
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    user_type: Yup.string()
      .oneOf(["Inspector", "User"], "Invalid user type")
      .required("User type is required"),
    employee_id: Yup.string().required("Employee ID is required"),
    password: Yup.string().required("Password is required"),
  });

  const handleOpenSaveModal = () => {
    console.log("handlleSave Modal");
    setOpenSaveModal(true);
  };
  console.log("sleected fsdd", selectedFiles);

  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      mobile: "",
      email: "",
      user_type: "",
      employee_id: "",
      password: "",
    },
    validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setFormError(null);
      setBackendErrors({});
      try {
        const fileUploadResult = await dispatch(uploadFiles(selectedFiles));
        console.log("File Upload Result:", fileUploadResult);

        if (!fileUploadResult.success) {
          throw new Error("File processing failed");
        }
        const processedFiles = fileUploadResult?.data?.data?.map((file) => ({
          originalName: file.name || file.originalName,
          fileName: file.path || file.fileName,
          filePath: file.path || file.filePath,
          fileSize: file.size || file.fileSize,
          fileType: file.type || file.fileType,
        }));

        const userTypeValue = values.user_type === "Inspector" ? 3 : 2;

        const inspectorData = {
          first_name: values.first_name,
          last_name: values?.last_name,
          email: values.email,
          user_type: userTypeValue,
          password: values.password,
          mobile: values.mobile,
          employee_id: values.employee_id,
          files: processedFiles,
        };
        if (!inspectorData.last_name) delete inspectorData.last_name;
        const response = await dispatch(addInspector(inspectorData));
        if (!response || response.error) {
          throw new Error(response?.error || "Failed to add inspector");
        }
        console.log("Add Inspector Response:", response);
        handleOpenSaveModal();
      } catch (error) {
        console.error("Form Submission Error:", error);
        if (error.response?.data?.message) {
          const backendFieldErrors = {};
          const errorMessage = error.response.data.message;
          console.log("Error message:", errorMessage);

          if (errorMessage.toLowerCase().includes("email already exists")) {
            backendFieldErrors.email = "Email already exists";
            formik.setFieldError("email", "Email already exists");
          }
          if (
            errorMessage
              .toLowerCase()
              .includes(
                'password must be minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character,"password" length must be at least 8 characters long'
              )
          ) {
            backendFieldErrors.password = "";
            formik.setFieldError("password", " ");
          }
          if (
            errorMessage.toLowerCase().includes("employee id already exist")
          ) {
            backendFieldErrors.employee_id = "Employee Id already exist";
            formik.setFieldError("employee_id", "Employee Id already exist");
          }
          setBackendErrors(backendFieldErrors);
          setFormError(errorMessage);
        } else {
          setFormError(
            error.message || "Failed to add inspector. Please try again."
          );
        }
      } finally {
        setSubmitting(false);
      }
    },
  });

  const hasBackendError = (fieldName) => {
    return Boolean(backendErrors[fieldName]);
  };

  const getErrorMessage = (fieldName) => {
    return (
      backendErrors[fieldName] ||
      (formik.touched[fieldName] && formik.errors[fieldName])
    );
  };

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleCloseSaveModal = () => {
    setOpenSaveModal(false);
    formik.resetForm();
    setSelectedFiles([]);
  };

  const handleBrowseFiles = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  // const handleRemoveFile = (fileName) => {
  //   setSelectedFiles((prevFiles) =>
  //     prevFiles.filter((file) => file.name !== fileName)
  //   );
  // };
  const handleRemoveFile = (fileName) => {
    setFileToRemove(fileName);
    setConfirmModal(true);
  };

  const confirmRemoveFile = () => {
    setSelectedFiles((prevFiles) =>
      prevFiles.filter((file) => file.name !== fileToRemove)
    );
    setUploadProgress((prevProgress) => {
      const newProgress = { ...prevProgress };
      delete newProgress[fileToRemove];
      return newProgress;
    });
    setConfirmModal(false);
    setFileToRemove(null);
  };

  const cancelRemoveFile = () => {
    setConfirmModal(false);
    setFileToRemove(null);
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setSelectedFiles((prevFiles) => [...prevFiles, ...files]);
  };

  const handleUpload = () => {
    selectedFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onprogress = (event) => {
        if (event.lengthComputable) {
          const progress = Math.round((event.loaded / event.total) * 100);
          setUploadProgress((prevProgress) => ({
            ...prevProgress,
            [file.name]: progress,
          }));
        }
      };
      reader.onload = () => {
        setUploadProgress((prevProgress) => ({
          ...prevProgress,
          [file.name]: 100,
        }));
      };
      reader.readAsArrayBuffer(file);
    });
  };

  const handleAddMore = () => {
    setOpenSaveModal(false);
    formik.resetForm();
    setSelectedFiles([]);
  };

  const handleDashboard = () => {
    navigate(DASHBOARD);
  };

  const handleNavigateinspector = () => {
    navigate(MANAGE_INSPECTOR);
  };

  const handleCancelClick = () => {
    setOpenSaveModal(false);
    formik.resetForm();
    setSelectedFiles([]);
    navigate(MANAGE_INSPECTOR);
  };

  const handleMobileChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,10}$/.test(value)) {
      formik.setFieldValue("mobile", value);
    }
  };

  const truncateString = (str) => {
    if (str?.length > 15) {
      return str.slice(0, 15) + "...";
    }
    return str;
  };

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-3xl font-bold mb-6">User Management</h2>
        <Breadcrumbs breadcrumbNameMap={breadcrumbNameMap} />
      </div>
      <div className="mx-auto bg-white shadow-lg rounded-lg p-8">
        <div>
          <h2 className="text-2xl font-base font-poppins mb-8 text-[#202224]">
            Add New Inspector / Guest User
          </h2>
        </div>
        <form onSubmit={formik.handleSubmit}>
          <div>
            <h3 className="text-base font-base text-[#1C3664] mb-2">
              Personal Details
            </h3>
            <div
              style={{ borderBottom: "3px solid #1C3664", width: "4%" }}
            ></div>
            <div className="space-y-4 md:space-y-6 pt-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                <TextField
                  label="First Name *"
                  name="first_name"
                  value={formik.values.first_name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.first_name &&
                    Boolean(formik.errors.first_name)
                  }
                  helperText={
                    formik.touched.first_name && formik.errors.first_name
                  }
                />
                <TextField
                  label="Last Name"
                  name="last_name"
                  value={formik.values.last_name}
                  onChange={formik.handleChange}
                />
                <TextField
                  label="Mobile Number *"
                  name="mobile"
                  value={formik.values.mobile}
                  // onChange={formik.handleChange}
                  onChange={handleMobileChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.mobile && Boolean(formik.errors.mobile)}
                  helperText={formik.touched.mobile && formik.errors.mobile}
                  type="tel"
                  inputProps={{ maxLength: 10 }}
                />
                <TextField
                  label="Email Address *"
                  name="email"
                  value={formik.values.email}
                  // onChange={formik.handleChange}
                  onChange={(e) => {
                    formik.handleChange(e);
                    if (backendErrors.email) {
                      setBackendErrors((prev) => ({ ...prev, email: null }));
                    }
                  }}
                  onBlur={formik.handleBlur}
                  error={
                    (formik.touched.email && Boolean(formik.errors.email)) ||
                    hasBackendError("email")
                  }
                  helperText={getErrorMessage("email")}
                  type="email"
                />

                <div className="w-full">
                  <select
                    id="user_type"
                    name="user_type"
                    value={formik.values.user_type}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className={`block w-full p-4 border rounded-md ${
                      formik.touched.user_type && formik.errors.user_type
                        ? "border-red-500"
                        : "border-gray-300"
                    }`}
                  >
                    <option value="" disabled>
                      Select user type
                    </option>
                    <option value="Inspector">Inspector</option>
                    <option value="User">User</option>
                  </select>
                  {formik.touched.user_type && formik.errors.user_type && (
                    <p className="text-red-500 text-sm mt-1">
                      {formik.errors.user_type}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div>
            <h3 className="text-base font-base text-[#1C3664] mt-6 mb-2">
              Default Password
            </h3>
            <div
              style={{ borderBottom: "3px solid #1C3664", width: "4%" }}
            ></div>
            <div className="space-y-4 md:space-y-6 pt-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
                <div className="relative">
                  <TextField
                    label="Default Password *"
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={formik.values.password}
                    // onChange={formik.handleChange}
                    onChange={(e) => {
                      formik.handleChange(e);
                      if (backendErrors.email) {
                        setBackendErrors((prev) => ({
                          ...prev,
                          password: null,
                        }));
                      }
                    }}
                    onBlur={formik.handleBlur}
                    error={
                      (formik.touched.password &&
                        Boolean(formik.errors.password)) ||
                      hasBackendError("password")
                    }
                    helperText={getErrorMessage("password")}
                    className="pr-10 w-full"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-2 top-[50%] transform -translate-y-1/2 text-gray-500"
                  >
                    {showPassword ? (
                      <FaEye size={24} />
                    ) : (
                      <IoMdEyeOff size={28} />
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div>
            <h3 className="text-base font-base text-[#1C3664] mt-6 mb-2">
              Employment Details
            </h3>
            <div
              style={{ borderBottom: "3px solid #1C3664", width: "4%" }}
            ></div>
            <div className="space-y-4 md:space-y-6 pt-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                <TextField
                  label="Inspector Employee ID *"
                  name="employee_id"
                  value={formik.values.employee_id}
                  onChange={(e) => {
                    formik.handleChange(e);
                    if (backendErrors.employee_id) {
                      setBackendErrors((prev) => ({
                        ...prev,
                        employee_id: null,
                      }));
                    }
                  }}
                  onBlur={formik.handleBlur}
                  error={
                    (formik.touched.employee_id &&
                      Boolean(formik.errors.employee_id)) ||
                    hasBackendError("employee_id")
                  }
                  helperText={getErrorMessage("employee_id")}
                />
              </div>
              <div className="bg-white p-4 flex items-center space-x-8">
                <div>
                  <p className="text-base font-base">
                    Upload Inspector Documents
                  </p>
                  <span className="text-gray-500 text-sm">
                    Only support .jpg, .png and pdf
                  </span>
                </div>
                <div>
                  <button
                    type="button"
                    className="bg-[#1C3664] flex text-white px-6 py-2 rounded-md shadow"
                    onClick={handleOpenModal}
                  >
                    <FaCloudUploadAlt
                      style={{
                        height: "20px",
                        marginTop: "2px",
                        width: "20px",
                      }}
                    />
                    &nbsp; Upload
                  </button>
                </div>
              </div>

              {selectedFiles.length > 0 && (
                <div className="mt-4">
                  <h4 className="text-lg font-semibold mb-2">
                    Uploaded Files:
                  </h4>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                    {selectedFiles.map((file, index) => (
                      <div
                        key={index}
                        className="flex items-center justify-between p-4 border border-gray-200 rounded-lg"
                      >
                        <div className="flex items-center space-x-3">
                          <img
                            // src={URL.createObjectURL(file)}
                            src={file_image}
                            alt="Inspector Document"
                            className="w-12 h-12 rounded-lg object-cover"
                          />
                          <div>
                            <p className="font-semibold">
                              {truncateString(file.name)}
                            </p>
                            <p className="text-sm text-gray-500">
                              {(file.size / 1024).toFixed(2)} KB
                            </p>
                          </div>
                        </div>
                        <div className="flex items-center space-x-2">
                          <button
                            type="button"
                            onClick={() => handleRemoveFile(file.name)}
                            className="text-red-500 hover:text-red-700"
                          >
                            Remove
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {formError && (
              <div className="text-red-500 mt-2">{error?.message}</div>
            )}

            <div className="flex justify-end space-x-4 ">
              <button
                type="button"
                onClick={handleCancelClick}
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-4 py-2 bg-[#1C3664] text-white rounded-md"
                disabled={isLoading || !formik.isValid}
              >
                {formik.isSubmitting ? "Saving..." : "Save Details"}
              </button>
            </div>
          </div>
        </form>
        <br />
      </div>

      {/* ................... Upload image modal ....................... */}

      <Modal open={openModal} className="justify-center items-center">
        <Box className="bg-white p-6 rounded-lg shadow-md max-w-lg mx-auto my-20">
          <RxCrossCircled
            onClick={handleCloseModal}
            className="float-end top-2 h-6 w-6 cursor-pointer"
          />
          <h2 className="text-lg font-bold mb-4">Documents Upload</h2>
          <p className="mb-2 text-sm text-gray-600">
            Add your documents here, and you can upload up to 5 files max
          </p>

          <div
            className="border-2 border-dashed border-gray-400 rounded-lg p-6 text-center mb-4"
            onClick={handleBrowseFiles}
          >
            <FaCloudUploadAlt className="mx-auto w-10 h-10 text-blue-600 mb-4" />
            <p className="text-sm text-gray-500">
              Drag your file(s) or{" "}
              <span className="text-blue-600 cursor-pointer">browse</span>
            </p>
            <p className="text-xs text-gray-400 mt-1">
              Max 10 MB files are allowed
            </p>
          </div>
          <input
            type="file"
            multiple
            onChange={handleFileChange}
            ref={fileInputRef}
            className="hidden"
            accept=".png, .jpg, .jpeg, .pdf, .svg"
          />

          <p className="text-xs text-gray-400">
            Only support .jpg, .png, and .pdf files
          </p>
          <div className="mt-4">
            {selectedFiles.map((file, index) => (
              <div
                key={index}
                className="relative flex items-center border border-gray-200 rounded-md p-2 mb-2"
              >
                <div className="w-10 h-10 mr-2">
                  <img
                    // src={URL.createObjectURL(file)}
                    src={file_image}
                    alt="file-icon"
                    className="w-full h-full object-cover rounded"
                  />
                </div>
                <div className="flex-grow">
                  <p className="text-sm font-semibold">
                    {truncateString(file.name)}
                  </p>
                  <p className="text-xs text-gray-500">
                    {(file.size / 1024).toFixed(2)} KB
                  </p>
                </div>
                <button
                  onClick={() => handleRemoveFile(file.name)}
                  className="absolute top-2 right-2 bg-gray-300 text-gray-600 rounded-full w-6 h-6 flex items-center justify-center"
                >
                  &times;
                </button>
              </div>
            ))}
          </div>

          <div className="mt-6 flex justify-end gap-4">
            <button
              onClick={handleCloseModal}
              className="bg-gray-300 px-4 py-2 rounded-md"
            >
              Cancel
            </button>
            <button
              onClick={() => {
                handleUpload();
                handleCloseModal();
              }}
              className="bg-[#1C3664] text-white px-4 py-2 rounded-md"
            >
              Done
            </button>
          </div>
        </Box>
      </Modal>

      {/* ...................... Success Modal ........................ */}
      <Modal open={openSaveModal} className="justiify-center items-center ">
        <Box className="bg-white text-center p-6 rounded-2xl shadow-md max-w-lg mx-auto my-20">
          <RxCrossCircled
            onClick={handleCloseSaveModal}
            className="float-end top-2 h-6 w-6 cursor-pointer"
          />
          <div className="text-center inline-flex mt-8">
            <div
              className="w-[72px] h-[72px] flex items-center justify-center"
              style={{ backgroundImage: `url(${SuccessBackground}` }}
            >
              <img src={Tick} alt="Success" className="w-7 h-7" />
            </div>
          </div>
          <p className="text-3xl text-[#0B0B0B] font-semibold mt-4 mb-4">
            Success
          </p>
          <span className="text-[#6D6D6D]">
            New Inspector added successfully
          </span>
          <div className="mt-6 flex justify-center gap-4">
            <button
              onClick={handleDashboard}
              className="bg-gray-300 px-4 py-2 rounded-lg"
            >
              Dashboard
            </button>
            <button
              onClick={handleAddMore}
              className="bg-[#1C3664] text-white px-4 py-2 rounded-lg"
            >
              Add More
            </button>
            <button
              onClick={handleNavigateinspector}
              className="bg-[#1C3664] text-white px-4 py-2 rounded-lg"
            >
              Inspector list
            </button>
          </div>
        </Box>
      </Modal>

      <Modal open={confirmModal} className="justify-center items-center">
        <Box className="bg-white p-6 rounded-lg shadow-md max-w-lg mx-auto my-20">
          <div className="text-center">
            <h2 className="text-xl font-semibold mb-4">Confirm Removal</h2>
            <p className="mb-6">Are you sure you want to remove this file?</p>
            <div className="flex justify-center gap-4">
              <button
                onClick={cancelRemoveFile}
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md"
              >
                Cancel
              </button>
              <button
                onClick={confirmRemoveFile}
                className="px-4 py-2 bg-red-500 text-white rounded-md"
              >
                Remove
              </button>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default AddInspector;
